"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { Input } from "@/components/shadcn/input";
import { Button } from "@/components/shadcn/button";
import { useSearchParams } from "next/navigation";
import LearnPopup from "@/components/shared/learnPopup";
import { useSession } from "next-auth/react";
import TabsSection from "./_tabsSection";

const LearnHeroSection: React.FC = () => {
  const rawPathname = usePathname();
  const pathname = rawPathname ?? "";
  const searchParams = useSearchParams();
  const router = useRouter();
  const { data: session } = useSession();
  const isAdmin = session?.user?.is_admin === true;

  const [inputValue, setInputValue] = useState("");

  const handleSearch = () => {
    const searchButton = document.getElementById("searchButton");
    searchButton?.classList.add("animate-pulse");
    searchButton?.classList.add("cursor-wait");
    router.push(`/learn/courses?search=${encodeURIComponent(inputValue)}`);
    const searchValue = searchParams?.get("search") || "";
    if (searchValue === inputValue) {
      searchButton?.classList.remove("animate-pulse");
      searchButton?.classList.remove("cursor-wait");
    }
  };

  useEffect(() => {
    const searchValue = searchParams?.get("search") || "";
    setInputValue(searchValue);
  }, [searchParams]);

  if (pathname.includes("/learn/course/")) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="max-w-7xl mx-auto w-full rounded-3xl overflow-hidden">
        {/* Background Section */}
        <div className="relative bg-secondary pt-12 px-6 md:px-12 overflow-hidden rounded-3xl">
          <div
            className="absolute inset-0 bg-[url('/next/next_assets/images/linen_texture.png')] bg-cover bg-no-repeat opacity-10"
            style={{
              borderRadius: "inherit", // Inherit border-radius from parent
            }}
          ></div>

          {/* Right image */}
          <div
            className="absolute right-0 top-0 h-full w-2/5 hidden md:block"
            style={{
              borderRadius: "inherit",
            }}
          >
            <Image
              src="/next/next_assets/images/training-1-2.png"
              alt="Woman using a laptop"
              className="dark:mix-blend-multiply"
              layout="fill"
              objectFit="cover"
              objectPosition="left-bottom"
            />
          </div>

          <div className="relative z-10">
            <div>
              <div className="flex flex-col gap-2">
                <h1 className="text-5xl text-left font-bold font-merriweather leading-[60px] tracking-tight text-primary dark:text-primary-25">
                  ProZ Learn
                </h1>
                <p className="w-full text-sm sm:text-base text-left text-black dark:text-accent-foreground">
                  Empowering freelance language professionals to succeed!
                </p>
              </div>
              {pathname.includes("/learn/courses") && (
                <div className="mt-4">
                  <div className="flex flex-col gap-3">
                    <div className="flex gap-2 w-full md:w-1/2 items-center">
                      <Input
                        className=""
                        placeholder="What do you want to learn today?"
                        type="text"
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearch();
                          }
                        }}
                        value={inputValue}
                      />
                      <Button
                        className="cursor-pointer"
                        size="default"
                        id="searchButton"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Navigation Tabs */}
            <TabsSection isAdmin={isAdmin} />
            {/* Divider */}
            <div className="bg-primary-200 h-[1px]"></div>
          </div>
        </div>
      </div>
      {/* Learn Popup Component */}
      <LearnPopup />
    </React.Fragment>
  );
};

export default LearnHeroSection;
